module.exports = __webpack_public_path__ + "static/media/icon_extension_rar.8744a5bb.svg";